// Section registry — the order in which sections render down the page.
//
// Each section is a separate module under ../sections/. The chrome's
// `mount()` walks this list, calls `shouldRender(project)`, and mounts
// the survivors in turn into the main scroll column.
//
// Sibling agents are populating the section files in parallel; this
// import list defines the contract they must satisfy (a default export
// implementing `CustomerSection`).

import type { CustomerSection } from "../types";
import projectOverview from "../sections/project-overview";
import quote from "../sections/quote";
import payments from "../sections/payments";
import designs from "../sections/designs";
import documents from "../sections/documents";
import tracking from "../sections/tracking";
import bookings from "../sections/bookings";
import warranty from "../sections/warranty";
import reviewPrompt from "../sections/review-prompt";
import messages from "../sections/messages";
import account from "../sections/account";
import aiAssistant from "../sections/ai-assistant";

// Section order. Notes:
//   - The kitchen journey is no longer a section: it renders as a
//     horizontal progress bar at the top of `project-overview` (Home),
//     derived live from the CRM stage + deliveries + calendar (Bug 4).
//   - `account` sits at the bottom (above the AI assistant) — settings
//     are a tail-end concern; the customer shouldn't have to scroll
//     past them to get to project info.
export const SECTIONS: readonly CustomerSection[] = [
  projectOverview,
  reviewPrompt,
  quote,
  payments,
  designs,
  documents,
  tracking,
  bookings,
  warranty,
  messages,
  account,
  aiAssistant,
] as const;
